<div class="sis-hint" [class]="'sis-hint sis-hint--' + tone">
  <span class="sis-hint-icon" aria-hidden="true">
    <ng-content select="[hint-icon]"></ng-content>
  </span>
  <span class="sis-hint-message">
    <ng-content></ng-content>
  </span>
</div>
